import { render, staticRenderFns } from "./FormSiNo.vue?vue&type=template&id=4bfc75d6&scoped=true"
import script from "./FormSiNo.vue?vue&type=script&lang=js"
export * from "./FormSiNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc75d6",
  null
  
)

export default component.exports